import getStore from '../data/store/store';
import updateCalendarEventsToDecline from '../actions/updateCalendarEventsToDecline';
import { orchestrator } from 'satcheljs';
import updateCalendarViewItems from '../data/mutators/updateCalendarViewItems';
import getCalendarViewService from 'owa-calendar-services/lib/services/getCalendarViewService';
import GetCalendarViewResponse from 'owa-service/lib/contract/GetCalendarViewResponse';
import { getStartDate, getEndDate } from '../selectors/getStoreProperties';

export default orchestrator(updateCalendarEventsToDecline, async () => {
    let optionState = getStore().currentState;
    if (optionState.declineExistingCalendarEventsEnabled) {
        let startDate = getStartDate();
        let endDate = getEndDate();
        await getCalendarViewService(startDate, endDate).then(
            (response: GetCalendarViewResponse) => {
                updateCalendarViewItems(response.Items);
            }
        );
    }
});
